import { fetchExperiment } from 'api/ExperimentsAPI';
import { Saga } from 'custom-types/saga';
import { ActionTypes } from 'modules/experiments/takeover/ducks/actionTypes';
import * as actions from 'modules/experiments/takeover/ducks/actions';
import {
  ExperimentTakeoverAction,
  FetchExperimentResponse,
  OriginalExperimentState,
} from 'modules/experiments/takeover/types';
import { getExperimentsTranslations } from 'modules/experiments/utils';
import { addNegativeToast, errorIdentifier } from 'modules/toastContainer';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { addToRootSaga } from 'store';
import { getTakeoverExperimentLocale } from '../selectors';

export function* fetchEditExperimentDataSaga({
  experimentId,
}: ExperimentTakeoverAction<{
  experimentId: number;
}>): Saga<ExperimentTakeoverAction<Record<string, unknown>, OriginalExperimentState>> {
  try {
    const currentLocale = yield select(getTakeoverExperimentLocale);
    const fetchDataParams = currentLocale ? [experimentId, currentLocale] : [experimentId];
    const {
      data: { experiment },
    }: FetchExperimentResponse = yield call(
      fetchExperiment,
      ...(fetchDataParams as [number, string]),
    );

    yield put(actions.experimentEditDataLoaded(experiment));
  } catch (error) {
    yield put(actions.experimentEditDataErrored());

    const errorMessage = yield call(
      getExperimentsTranslations,
      'errorMessage.fetchExperimentAnalytics',
    );
    yield put(
      addNegativeToast(
        errorMessage,
        errorIdentifier({
          errorMessage,
          source: 'fetchEditExperimentDataSaga',
          error,
        }),
      ) as any,
    );
  }
}

addToRootSaga([takeLatest(ActionTypes.DRAWER_OPEN, fetchEditExperimentDataSaga)]);
